import {
  convertDateToYYYYMMFormat,
  MonthYearDatePicker,
  PageWrapper,
  STATUSPAGE,
} from '@repo/ui';
import { HandleStudentReportDailyWorkload } from 'domain/usecases';
import { useFormik } from 'formik';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useCallback, useState } from 'react';
import { Card, Col, FormGroup, Input, Label, Spinner } from 'reactstrap';
import * as Yup from 'yup';

const StudentReportDailyWorkload = () => {
  const [buttonSelectedSubmit, setButtonSelectedSubmit] =
    useState<string>(null);
  const [statusGet, setStatusGet] = useState<STATUSPAGE>();

  // Hooks
  const { reportService } = useService();

  //Validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entity: null,
      course: null,
      model: 'grouped',

      unit: null,
      semester: {
        value: null,
      },
      groups: [],
      period: convertDateToYYYYMMFormat(new Date()).slice(0, 7),
      validation: null,
    },
    validationSchema: Yup.object({
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      groups: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      period: Yup.string().nullable(),

      semester: Yup.object()
        .shape({
          label: Yup.string().nullable(),
          value: Yup.string().nullable(),
        })
        .nullable(),
      validation: Yup.string().nullable(),
      model: Yup.string().nullable(),
    }),

    onSubmit: (values) => {
      const groupsValues = values.groups.map((group) => group.value);
      {
        buttonSelectedSubmit === 'export-pdf' &&
          requestStudentReportDailyWorkload({
            course: values.course?.value,
            period: values.period,
            validation: values.validation,
            groups: groupsValues,
            curricularUnit: values.unit?.value,
            semester: values?.semester?.value,
            entity: values?.entity?.value,
            type: '0',
            model: values.model,
          });
      }
      {
        buttonSelectedSubmit === 'export-excel' &&
          requestStudentReportDailyWorkload({
            course: values.course?.value,
            period: values.period,
            validation: values.validation,
            groups: groupsValues,
            curricularUnit: values.unit?.value,
            semester: values?.semester?.value,
            entity: values?.entity?.value,
            type: '1',
            model: values.model,
          });
      }
    },
  });

  // Methods
  const requestStudentReportDailyWorkload = useCallback(
    async (params: HandleStudentReportDailyWorkload.Params) => {
      setStatusGet(STATUSPAGE.LOADING);

      await reportService
        .handleStudentReportDailyWorkload(params)
        .then((res: HandleStudentReportDailyWorkload.Result) => {
          let blob = new Blob([res], {
            // type: `application/${'pdf'}`,
            type: `application/${params?.type === '0' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setStatusGet(STATUSPAGE.DONE);
        });
    },
    [],
  );

  return (
    <PageWrapper title="Carga Horária Diária">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>Carga Horária Diária</h4>
      </Col>
      <Card>
        <ReportsGeneralFilters
          validation={validation}
          inputsChildren={
            <>
              <Col xl={2} className="d-flex flex-column mb-3">
                <Label>Período:</Label>
                <MonthYearDatePicker
                  fieldName="period"
                  validation={validation}
                />
              </Col>
              <Col xl={4} className="d-flex flex-column">
                <Label>Validação:</Label>
                <div className="d-flex gap-4">
                  <FormGroup>
                    <Input
                      name="validation"
                      id="all"
                      type="radio"
                      value={null}
                      checked={!validation.values.validation as any}
                      onChange={(e) => {
                        if (e.target.checked) {
                          validation.handleChange({
                            target: {
                              name: 'validation',
                              value: null,
                            },
                          });
                        }
                      }}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label htmlFor="all" className="ms-1 form-check-label">
                      Todas
                    </Label>
                  </FormGroup>

                  <FormGroup>
                    <Input
                      name="validation"
                      id="validated"
                      type="radio"
                      value="1"
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label
                      htmlFor="validated"
                      className="ms-1 form-check-label"
                    >
                      Validadas
                    </Label>
                  </FormGroup>

                  <FormGroup>
                    <Input
                      name="validation"
                      id="not-validated"
                      type="radio"
                      value="2"
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label
                      htmlFor="not-validated"
                      className="ms-1 form-check-label"
                      onChange={validation.handleChange}
                    >
                      Rejeitadas
                    </Label>
                  </FormGroup>

                  <FormGroup>
                    <Input
                      name="validation"
                      id="rejected"
                      type="radio"
                      value="3"
                      onChange={validation.handleChange}
                      className="form-check-input"
                      style={{ cursor: 'pointer' }}
                    />
                    <Label htmlFor="rejected" className="ms-1 form-check-label">
                      Pendente
                    </Label>
                  </FormGroup>
                </div>
              </Col>
              <Col>
                <Col xl={6}>
                  <Label>Modelo:</Label>
                  <div className="d-flex gap-4">
                    <FormGroup>
                      <Input
                        name="model"
                        id="grouped-by-group"
                        type="radio"
                        value="grouped"
                        checked={validation.values.model === 'grouped'}
                        onChange={validation.handleChange}
                        className="form-check-input"
                        style={{ cursor: 'pointer' }}
                      />
                      <Label
                        htmlFor="grouped-by-group"
                        className="ms-1 form-check-label"
                      >
                        Agrupado por grupo
                      </Label>
                    </FormGroup>
                    <FormGroup>
                      <Input
                        name="model"
                        id="consolidated"
                        type="radio"
                        value="consolidated"
                        onChange={validation.handleChange}
                        className="form-check-input"
                        style={{ cursor: 'pointer' }}
                      />
                      <Label
                        htmlFor="consolidated"
                        className="ms-1 form-check-label"
                      >
                        Consolidado
                      </Label>
                    </FormGroup>
                  </div>
                </Col>
              </Col>
            </>
          }
          buttonsChildren={
            <div className="d-flex gap-2 justify-content-end align-content-end">
              <button
                type="submit"
                id="export-pdf"
                onClick={() => {
                  setButtonSelectedSubmit('export-pdf');
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={statusGet === STATUSPAGE.LOADING && true}
              >
                {buttonSelectedSubmit === 'export-pdf' &&
                statusGet === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </button>
              <button
                id="export-excel"
                type="submit"
                onClick={() => {
                  setButtonSelectedSubmit('export-excel');
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={statusGet === STATUSPAGE.LOADING && true}
              >
                {buttonSelectedSubmit === 'export-excel' &&
                statusGet === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ri-file-excel-2-line mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
        />
      </Card>
    </PageWrapper>
  );
};

export default StudentReportDailyWorkload;
